import { Grid, Tab, Tabs } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { ProfileContext, ProfileContextPayload } from "../../Context/ProfileDetailsContext";
import RothAccountValue from "../Profile/AnnuityProfiles/ProfileNewAnnuityRothConversion/ProfileRothConversionTabs/RothAccountValue";
import RothTaxes from "../Profile/AnnuityProfiles/ProfileNewAnnuityRothConversion/ProfileRothConversionTabs/RothTaxes";
import RothRetirementIncome from "../Profile/AnnuityProfiles/ProfileNewAnnuityRothConversion/ProfileRothConversionTabs/RothRetirementIncome";
import globalRothStyles from "../../Styles/ComponentStyles/ProfileStyle/ProfileRothConversion/ProfileRothConversionIndex.module.scss"
import CustomNumberTextField from "../../GlobalComponent/CustomNumberTextField/CustomNumberTextField";
import GlobalTabsComponent from "../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent";

const RothOutput = () => {
    const [tabNavigationValue, setTabNavigationValue] = useState<string>('1');
    const [selectedAge, setSelectedAge] = useState<number>(0);
    const [minAge, setMinAge] = useState<number>(0);
    const [maxAge, setMaxAge] = useState<number>(0);

    const {
        profileRothConversionDetails
    } = useContext(ProfileContext) as ProfileContextPayload

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabNavigationValue(newValue);
    };

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;

    const inputBlureChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(minAge), Number(maxAge), val)
        if (checkInBeetween == false) {
            if (val >= Number(maxAge))
                setSelectedAge(Number(maxAge))
            else {
                setSelectedAge(Number(minAge))
            }
            return
        }
    }

    useEffect(() => {
        if (minAge > 0) {
            setSelectedAge(minAge);
        }
    }, [minAge]);

    useEffect(() => {
        if (profileRothConversionDetails) {
            const yearlyBreakdown = profileRothConversionDetails?.data[0]?.yearly_breakdown || {};
            const ageKeys = Object.keys(yearlyBreakdown).map(Number);
            if (ageKeys.length > 0) {
                const min = Math.min(...ageKeys);
                const max = Math.max(...ageKeys);
                setMinAge(min);
                setMaxAge(max);
            }
        }
    }, [profileRothConversionDetails])

    return (
        <>
            <Grid container>
                <Grid item xs={12}
                    sx={{
                        backgroundColor: "#fff",
                        padding: "0px 20px",
                        borderBottom: "1px solid #E2E8F0"
                    }}>
                    <Grid container sx={{ justifyContent: "space-between" }}>
                        <Grid item className={globalRothStyles.tabsWrapper}>
                            <GlobalTabsComponent
                                value={tabNavigationValue}
                                onChange={handleTabChange}
                                normalColor="#45556C"
                                selectedColor="#04385D"
                                indicatorColor="#04385D"
                                tabs={[
                                    { label: "Account Value", value: "1" },
                                    { label: "Taxes", value: "2" },
                                    { label: "Retirement Income", value: "3" },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} item padding={"0px 20px"} className={globalRothStyles.rothCardAgeComponentItem}>
                    <Grid container sx={{ alignItems: "center", height: "100%", gap: "10px", justifyContent: "flex-end" }}>
                        <Grid item className={globalRothStyles.rothCardText}>
                            Age
                        </Grid>
                        <Grid item>
                            <CustomNumberTextField
                                type="number"
                                size="small"
                                variant="outlined"
                                value={isNaN(selectedAge) ? '' : selectedAge}
                                onChange={(e) => {
                                    const value = e?.target?.value;

                                    if (value === '') {
                                        setSelectedAge(NaN); // Or just '' if you're okay with a string state temporarily
                                        return;
                                    }

                                    const numericValue = Number(value);
                                    // if (numericValue >= minAge && numericValue <= maxAge) {
                                    setSelectedAge(numericValue);
                                    // }
                                }}
                                InputProps={{ inputProps: { min: minAge, max: maxAge } }}
                                onBlur={inputBlureChangeYear}
                                customStyles={{
                                    backgroundColor: "white",
                                    color: "black"
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {
                        tabNavigationValue == "1" && <RothAccountValue selectedAge={selectedAge} />
                    }
                    {
                        tabNavigationValue == "2" && <RothTaxes selectedAge={selectedAge} />
                    }
                    {
                        tabNavigationValue == "3" && <RothRetirementIncome selectedAge={selectedAge} />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default RothOutput